export const mapMapValues = <TKey, TValueIn, TValueOut>(
  mapObj: Map<TKey, TValueIn>,
  mapFunc: (value: TValueIn) => TValueOut,
): Map<TKey, TValueOut> => {
  const outMap = new Map<TKey, TValueOut>();

  for (const [key, val] of mapObj.entries()) {
    outMap.set(key, mapFunc(val));
  }

  return outMap;
};
